export enum CurrencySymbol {
  USD = '$',
  EUR = '€',
  GBP = '£',
  MXN = 'Mex$',
  ARS = 'Arg$',
  CLP = 'Ch$',
  BRL = 'R$',
  COP = 'Col$',
  CRC = '₡',
  DOP = 'RD$',
  PEN = 'S/',
  PAB = 'B/.',
  UYU = '$U',
}

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  MXN = 'MXN',
  ARS = 'ARS',
  CLP = 'CLP',
  BRL = 'BRL',
  COP = 'COP',
  CRC = 'CRC',
  DOP = 'DOP',
  PEN = 'PEN',
  PAB = 'PAB',
  UYU = 'UYU',
}

export const convertCurrencyToSymbol = (currency: Currency): CurrencySymbol => {
  switch (currency) {
    case Currency.EUR:
      return CurrencySymbol.EUR;
    case Currency.MXN:
      return CurrencySymbol.MXN;
    case Currency.ARS:
      return CurrencySymbol.ARS;
    case Currency.BRL:
      return CurrencySymbol.BRL;
    case Currency.CLP:
      return CurrencySymbol.CLP;
    case Currency.COP:
      return CurrencySymbol.COP;
    case Currency.CRC:
      return CurrencySymbol.CRC;
    case Currency.DOP:
      return CurrencySymbol.DOP;
    case Currency.PEN:
      return CurrencySymbol.PEN;
    case Currency.PAB:
      return CurrencySymbol.PAB;
    case Currency.UYU:
      return CurrencySymbol.UYU;
    default:
      return CurrencySymbol.USD;
  }
};
